import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50edc6a6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./treatmentDetailPlan.scss?vue&type=style&index=0&id=50edc6a6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50edc6a6",
  null
  
)

export default component.exports